module.exports = __webpack_public_path__ + "img/effective-negotiator.2431e30b.svg";